import Swiper, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCreative,
  FreeMode,
} from "swiper";
import { isMobileViewport } from "../utilities/ViewportHelpers";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, EffectCreative, FreeMode]);

document.addEventListener("DOMContentLoaded", () => {
  // init Swiper: Service Rotator
  const serviceRotatorEls = document.querySelectorAll<HTMLElement>(
    ".service-rotator .swiper"
  );
  [...serviceRotatorEls].forEach((el) => {
    const slideEls = el.querySelectorAll(".swiper-slide");
    const isTablePlusEnabled = slideEls.length > 3;

    if (!isTablePlusEnabled) {
      el.classList.add("disabled--tabletplus");
    }

    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 30,

      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 12,
          centeredSlides: true,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 26,
        },
        767: {
          enabled: isTablePlusEnabled,
          slidesPerView: 3,
          spaceBetween: 26,
          allowTouchMove: false,
        },
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  // init Swiper: Benefits Rotator
  const benefitsRotatorEls = document.querySelectorAll<HTMLElement>(
    ".benefits-rotator .swiper"
  );
  [...benefitsRotatorEls].forEach((el) => {
    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 30,
      effect: isMobileViewport() ? "slide" : "fade",
      fadeEffect: {
        crossFade: true,
      },

      breakpoints: {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 18,
          // centeredSlides: true
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
          direction: "vertical",
          // autoHeight: true
        },
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });

  // init Swiper: Customer Testimonials Rotator
  const ctRotatorEls = document.querySelectorAll<HTMLElement>(
    ".customer-testimonials-rotator .swiper"
  );
  [...ctRotatorEls].forEach((el) => {
    new Swiper(el, {
      slidesPerView: 1,
      effect: isMobileViewport() ? "slide" : "fade",
      fadeEffect: {
        crossFade: true,
      },

      breakpoints: {
        320: {
          slidesPerView: 1,
          // spaceBetween: 18,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
          direction: "vertical",
          autoHeight: true,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  // init Swiper: Service Rotator
  const employeeSpotlightRotatorEls = document.querySelectorAll<HTMLElement>(
    ".employee-spotlight .swiper"
  );
  [...employeeSpotlightRotatorEls].forEach((el) => {
    const slideEls = el.querySelectorAll(".swiper-slide");
    const isTablePlusEnabled = slideEls.length > 4;

    if (!isTablePlusEnabled) {
      el.classList.add("disabled--tabletplus");
    }

    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 30,
      freeMode: true,

      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 26,
        },
        576: {
          slidesPerView: 2.2,
          spaceBetween: 26,
        },
        767: {
          enabled: isTablePlusEnabled,
          slidesPerView: 4,
          spaceBetween: 26,
        },
      },
    });
  });

  // init Swiper: Colorful Slider
  const colorfulSliderEls = document.querySelectorAll<HTMLElement>(
    ".colorful-slider .swiper"
  );
  [...colorfulSliderEls].forEach((el) => {
    // const slideEls = el.querySelectorAll('.swiper-slide');

    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 30,
      freeMode: true,

      breakpoints: {
        320: {
          slidesPerView: 1.4,
          spaceBetween: 24,
        },
        576: {
          slidesPerView: 2.4,
          spaceBetween: 26,
        },
        767: {
          slidesPerView: 4.3,
          spaceBetween: 24,
        },
      },
    });
  });

  // init Swiper: dumpster card Rotator
  const cardDumpsterRotatorEls = document.querySelectorAll<HTMLElement>(
    ".card-dumpster .swiper"
  );
  [...cardDumpsterRotatorEls].forEach((el) => {
    const slideEls = el.querySelectorAll(".swiper-slide");
    const activeIndex = Number(
      el.querySelector(".indexactive")?.getAttribute("data-active")
    );
    const isTablePlusEnabled = slideEls.length > 4;

    if (!isTablePlusEnabled) {
      el.classList.add("disabled--tabletplus");
    }

    const swiper = new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 0,
      freeMode: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
      },

      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 0,
        },
        576: {
          slidesPerView: 2.2,
          spaceBetween: 0,
        },
        767: {
          enabled: isTablePlusEnabled,
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
    });
    if (activeIndex) {
      swiper.update();
      swiper.slideTo(activeIndex);
      swiper.update();
    }
  });
});
